import { CAL_GPU_CARD_MNG } from '@/api/apiModules'
export default {
  viewType: 'form',
  module: CAL_GPU_CARD_MNG,
  params: null,
  view: {
    title: '创建显卡',
    labelPosition: 'right',
    labelWidth: '300px',
    width: '750px',
    content: [
      {
        $id: 'name',
        $type: 'input',
        label: '显卡名称',
        $el: {
          placeholder: '请输入显卡名称',
          suffixIcon: 'el-icon-edit'
        },
        rules: [
          {
            notEmpty: '显卡名称'
          }
        ]
      },
      {
        $id: 'serverMaxSupport',
        $type: 'input-number',
        label: '服务器支持的最大显卡张数',
        $el: {
          placeholder: '请输入显卡张数',
          suffixIcon: 'el-icon-edit',
          min: 1
        },
        rules: [
          {
            notEmpty: '服务器支持的最大显卡张数'
          }
        ]
      },
      {
        $id: 'capacity',
        $type: 'input-number',
        label: '显存大小（GB）',
        $el: {
          placeholder: '请输入显存大小',
          suffixIcon: 'el-icon-edit',
          min: 1
        },
        rules: [
          {
            notEmpty: '显存大小'
          }
        ]
      },
      {
        $id: 'dividedContent',
        $type: 'select',
        $el: {
          clearable: true,
          multiple: true,
          filterable: true,
          'allow-create': true,
          'default-first-option': true,
          showArrowIcon: false,
          placeholder: '请输入显卡切分模式'
        },
        rules: [
          {
            notEmpty: '显卡切分模式'
          }
        ],
        label: '显卡切分模式',
        format: function(mate, value) {
          return value || []
        }
      }
    ]
  }
}
